import { InjectionToken } from '@angular/core';
import { defaultGaSessionConfig, GaSessionConfig } from '../../session/index';
import { defaultGaApplicationsConfig, GaApplicationsConfig } from './../../applications/index';
import { defaultGaI18nConfig, GaI18nConfig } from './I18nConfig';
import { defaultGaShellConfig, GaShellConfig } from './ShellConfig';

export class GaConfig {
    applications?: GaApplicationsConfig;
    i18n?: GaI18nConfig;
    session?: GaSessionConfig;
    shell?: GaShellConfig;
    [key: string]: any;

    constructor(options?: GaConfig) {
        this.applications = options?.applications ?? new GaApplicationsConfig();
        this.i18n = options?.i18n ?? new GaI18nConfig();
        this.session = options?.session ?? new GaSessionConfig();
        this.shell = options?.shell ?? new GaShellConfig();
    }
}

export const GA_CONFIG = new InjectionToken<GaConfig[]>('GA config');
export const GA_CONFIG_FROM_FILE = new InjectionToken<GaConfig>('GA config from file. Can\'t be "multi"');

export const defaultGaConfig: GaConfig = new GaConfig({
    applications: defaultGaApplicationsConfig,
    i18n: defaultGaI18nConfig,
    session: defaultGaSessionConfig,
    shell: defaultGaShellConfig
});
